import script from "./ThreeColImageTextCol.vue?vue&type=script&setup=true&lang=js"
export * from "./ThreeColImageTextCol.vue?vue&type=script&setup=true&lang=js"

import "./ThreeColImageTextCol.vue?vue&type=style&index=0&id=1376db57&scoped=true&lang=css"

import exportComponent from "/home/richard/Code/CHE/project/resources/frontend/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1376db57"]])

export default __exports__